import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";

export const CopyLink = ({ label, link }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset after 2 sec
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    return (
        <div className="mb-3">
            <label className="form-label">{label}</label>
            <div className="input-group">
                <input
                    type="text"
                    className="bg-black text-white border-0 py-2 form-control custom-padding-inputs"
                    value={link}
                    readOnly
                />
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={handleCopy}
                >
                    {copied ? (
                        <FontAwesomeIcon icon={faCheck} />
                    ) : (
                        <FontAwesomeIcon icon={faCopy} />
                    )}
                </button>
            </div>
        </div>
    )
}
